import page1 from "../assets/page1.png";
import page2 from "../assets/page2.png";
import page3 from "../assets/page3.png";
import page5 from "../assets/page5.png";
import page6 from "../assets/page6.png";
import page7 from "../assets/page7.png";
import page8 from "../assets/page8.png";
import page9 from "../assets/page9.png";
import page11 from "../assets/page11.png";
/* import page10 from "../assets/page10.png"; */
/* import page1 from "../assets/page1.png"; */
/* import page4 from "d../assets/page4.png"; */

export const DETAILS = [
  {
    id: 1,
    title: "Consultoría Integral",
    tecnology: "React | SASS",
    description:
      "Este emprendimiento es una iniciativa de Natali Ruiz de Galarreta, quien busca emplear una consultoría integral que genera soluciones sostenibles para empresas pequeñas. En este proyecto trabajé de la mano con la diseñadora UX/UI Bianca Nadine Olsson y el desarrollador Juan Ruiz.",
    github: "https://github.com/jmr85/consultoria",
    link: "https://natali.ruizdegalarreta.com.ar/",
    img: page1,
  },
  {
    id: 2,
    title: "Cirse e-commerce",
    tecnology: "JavaScript | Firebase | SASS",
    description:
      "Este sitio web, desarrollado en Javascript, es una tienda virtual de moda en la que se pueden adquirir vestidos y accesorios. Incluye opciones como la posibilidad de filtrar productos por categorías o precio, agregar artículos al carrito y completar la compra.",
    github: "https://github.com/diaslucia/cirse",
    link: "https://cirse.netlify.app/",
    img: page2,
  },
  {
    id: 3,
    title: "Blockbuster e-commerce",
    tecnology: "React | Firebase | SASS",
    description:
      "Este sitio web, desarrollado en React JS, es una tienda virtual para la compra de películas y series. Ofrece la opción de agregar productos al carrito y completar la compra, con la capacidad de almacenar la orden en Firebase y generar un número de referencia.",
    github: "https://github.com/diaslucia/virtual-blockbuster",
    link: "https://blockbuster-virtual.000webhostapp.com/",
    img: page3,
  },
  {
    id: 4,
    title: "Queen Be",
    tecnology: "Next JS | SASS",
    description:
      "Este sitio web fue gestionado por Notimation, y asumí la responsabilidad de la maquetación. Fue construido utilizando Next.js y Sass.",
    link: "https://www.queenbe.io/",
    img: page6,
  },
  {
    id: 5,
    title: "Mecatrónica",
    tecnology: "Wordpress",
    description:
      "Esta página web fue gestionada por Nexo Digital, en la cual asumí la responsabilidad del diseño y la implementación.",
    link: "https://mecatronicadiesel.com/",
    img: page5,
  },
  {
    id: 6,
    title: "DAxes",
    tecnology: "Next JS | SASS",
    description:
      "Este sitio web fue gestionado por Notimation, y asumí la responsabilidad de la maquetación. Fue construido utilizando Next.js y Sass.",
    link: "https://www.daxes.io/",
    img: page7,
  },
  {
    id: 7,
    title: "Donuts",
    tecnology: "Vue | Vuex | Vue Router | Vue Form",
    description:
      "Este sitio web fue desarrollado utilizando Vue y MockAPI como servidor de API. Sirve como una plataforma de comercio electrónico, ofreciendo funcionalidades de registro y inicio de sesión de usuarios. Los clientes pueden registrarse e iniciar sesión para comprar deliciosas donas y acceder a su historial de pedidos. Por otro lado, los administradores tienen derechos de acceso especiales que les permiten agregar, eliminar o modificar productos, así como ver todos los pedidos de los clientes.",
    github: "https://github.com/diaslucia/project-vue",
    link: "https://project-jmnhkxgaq-diaslucia.vercel.app/",
    img: page8,
  },
  {
    id: 8,
    title: "MeLi",
    tecnology: "React | SASS | Redux Toolkit | Jest | Formik & Yup",
    description:
      "Este proyecto representa un ejercicio colaborativo de desarrollo de front-end, dirigido a mejorar las habilidades de los participantes, especialmente en React, como parte de una aceleración avanzada en Alkemy que abarcó un período de 7 semanas. La aplicación es una réplica de la plataforma de Mercado Libre y se ha construido utilizando la API proporcionada por la empresa. Sus funciones clave incluyen el registro y autenticación de usuarios, búsqueda de productos, visualización de resultados de búsqueda, detalles de productos, la capacidad de agregar artículos al carrito y finalizar la compra.",
    github: "https://github.com/Meli-clone/meli-clone",
    link: "https://meli-clon.netlify.app/",
    img: page9,
  },
  {
    id: 9,
    title: "SpaceX",
    tecnology: "React | TypeScript | Auth0 | SASS",
    description:
      "Este proyecto utiliza la API de SpaceX, permitiendo a los usuarios iniciar sesión y acceder a información sobre los cohetes. El objetivo principal de su creación fue practicar el uso de Apollo GraphQL para consumir la API e implementar Auth0 para la autenticación con JWT.",
    github: "https://github.com/diaslucia/spacex",
    img: page11,
  },
];

export const DETAILSEN = [
  {
    id: 1,
    title: "Consulting Services",
    tecnology: "React JS | SASS",
    description:
      "Natali Ruiz de Galarreta offers consulting services for small business that want to become more sustainable. I worked along with Bianca Nadine Olsson, an UX/UI designer, and Juan Ruiz, a web developer.",
    github: "https://github.com/jmr85/consultoria",
    link: "https://natali.ruizdegalarreta.com.ar/",
    img: page1,
  },
  {
    id: 2,
    title: "Cirse e-commerce",
    tecnology: "Javascript | Firebase | SASS",
    description:
      "This website serves as a virtual fashion store, offering a selection of dresses and accessories for purchase. It includes features such as the ability to filter products by categories or price, add items to the shopping cart, and complete the purchase.",
    github: "https://github.com/diaslucia/cirse",
    link: "https://cirse.netlify.app/",
    img: page2,
  },
  {
    id: 3,
    title: "Blockbuster e-commerce",
    tecnology: "React JS | Firebase | SASS",
    description:
      "This website, built using React JS, is an online store for purchasing movies and series. It provides the option to add products to the cart and complete the purchase, with the ability to store the order in Firebase and generate a reference number.",
    github: "https://github.com/diaslucia/virtual-blockbuster",
    link: "https://blockbuster-virtual.herokuapp.com/",
    img: page3,
  },
  {
    id: 4,
    title: "Queen Be",
    tecnology: "Next JS | SASS",
    description:
      "This website was managed by Notimation, and I assumed responsibility for layout. It was built using Next.js and Sass.",
    link: "https://www.queenbe.io/",
    img: page6,
  },
  {
    id: 5,
    title: "Mecatrónica",
    tecnology: "Wordpress",
    description:
      "This website was managed by Nexo Digital, where I was in charge of the design and implementation.",
    link: "https://mecatronicadiesel.com/",
    img: page5,
  },
  {
    id: 6,
    title: "DAxes",
    tecnology: "Next JS | SASS",
    description:
      "This website was managed by Notimation, and I assumed responsibility for layout. It was built using Next.js and Sass.",
    link: "https://www.daxes.io/",
    img: page7,
  },
  {
    id: 7,
    title: "Donuts",
    tecnology: "Vue JS | Vuex | Vue Router | Vue Form",
    description:
      "This website was developed using Vue and MockAPi as an API server. It serves as an e-commerce platform, offering user registration and login functionalities. Customers can register and log in to purchase delicious donuts and access their order history. On the other hand, administrators have special access rights, enabling them to add, delete, or modify products, as well as view all client orders.",
    github: "https://github.com/diaslucia/project-vue",
    link: "https://project-jmnhkxgaq-diaslucia.vercel.app/",
    img: page8,
  },
  {
    id: 8,
    title: "MeLi",
    tecnology: "React | SASS | Redux Toolkit | Jest | Formik & Yup",
    description:
      "This project is a collaborative front-end exercise aimed at improving participants' skills, primarily in React, as part of an advanced acceleration program at Alkemy over a period of 7 weeks. The application is a clone of the Mercado Libre website, for which the company's API has been utilized. The main application functions include user registration and authentication, product search, a view displaying search results, product details, adding items to the cart, and performing checkout.",
    github: "https://github.com/Meli-clone/meli-clone",
    link: "https://meli-clon.netlify.app/",
    img: page9,
  },
  {
    id: 9,
    title: "SpaceX",
    tecnology: "React | TypeScript | Auth0 | SASS",
    description:
      "This website utilizes the SpaceX API, allowing users to log in and access information about the rockets The core aim of its creation was to practice using Apollo GraphQL to consume the API and implement Auth0 for JWT authentication.",
    github: "https://github.com/diaslucia/spacex",
    img: page11,
  },
];
